import React from 'react';
import PropTypes from 'prop-types';

import ProductComponents from './Features/ProductComponents';
import { mapPropsToInitialState } from './mapPropsToInitialState';

import '../product-shared.css';
import './CabinetProducts.css';


class ProductApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = mapPropsToInitialState(props);

    this.onSelectVariation = this.onSelectVariation.bind(this);
    this.updateWishlists = this.updateWishlists.bind(this);
  }

  onSelectVariation(variationCode) {
    if (variationCode !== null) {
      this.setState((prevState) => ({
        currentVariation: prevState.variations.find((variation) => (variation.Code === variationCode))
      }));
    }
  }

  updateWishlists(wishlists) {
    this.setState(({wishlistModel}) => {
      wishlistModel.Wishlists = wishlists;
      return {wishlistModel};
    })
  }

  render() {
    const defaultAssetsGroup = this.props.AssetsGroups.find(gp => gp.GroupName === 'default');
    const siteInfo = {
      siteName: this.props.SiteName,
      phoneNumber: this.props.PhoneNumber,
      phoneText: this.props.PhoneText
    };

    return (
      <ProductComponents
          addToCartEndpoint={this.state.addToCartEndpoint}
          assets={defaultAssetsGroup && defaultAssetsGroup.Assets}  
          blogs={this.props.RelatedBlogs}
          categoryId={this.props.ParentCategoryContentLinkId}
          currentVariation={this.state.currentVariation}
          dealerDocuments={this.props.DealerDocuments}
          documentWarranties={this.props.DocumentWarranties}
          filterForReicoExpress={this.props.FilterForReicoExpress}
          gallery={this.props.ProjectGallery}
          isColorPicker={false}
          onSelectVariation={this.onSelectVariation}
          siteInfo={siteInfo}
          trait1Selected={this.state.trait1Selected}
          trait2Selected={this.state.trait2Selected}
          traits={this.state.traits}
          variations={this.state.variations}
          videos={this.props.VideoGallery}
          customerType={this.state.customerType}
          siteName={this.state.siteName}
          wishlistModel={this.state.wishlistModel}
          updateWishlists={this.updateWishlists}
      />
    );
  }
}

ProductApp.propTypes = {
  Variations: PropTypes.array.isRequired,
  ShowBuyButton: PropTypes.bool,
  ShowAddToQuoteButton: PropTypes.bool,
  PriceViewModel: PropTypes.object,
  Name: PropTypes.string.isRequired,
  ProjectGallery: PropTypes.object,
  VideoGallery: PropTypes.object,
  DocumentWarranties: PropTypes.object,
  DealerDocuments: PropTypes.array,
  RelatedBlogs: PropTypes.object,
  ParentCategoryContentLinkId: PropTypes.number,
  FilterForReicoExpress: PropTypes.bool,
  SiteName: PropTypes.string,
  PhoneNumber: PropTypes.string,
  PhoneText: PropTypes.string,
  Trait1Selected: PropTypes.string,
  Trait2Selected: PropTypes.string,
  WishlistModel: PropTypes.object
};

export default ProductApp;